const SPAN_CLASS = "sb-tour-span-target";

/**
 * spanTourTarget — one tour target covering a run of adjacent elements.
 *
 * AntD Tour spotlights a single element, so a step that explains two
 * neighbouring table columns can only light up one of their header cells. This
 * lays an invisible box from the left edge of `first` to the right edge of
 * `last` and returns it as the target. The box is parented to `first`, so it
 * scrolls with the table instead of drifting when the table scrolls sideways.
 *
 *   target: () => spanTourTarget(openHeaderCell, discoverableHeaderCell)
 *
 * Falls back to `first` alone when `last` can't be found.
 */
export default function spanTourTarget(first, last) {
  if (!first || !last) return first ?? null;

  let span = first.querySelector(`:scope > .${SPAN_CLASS}`);
  if (!span) {
    span = document.createElement("div");
    span.className = SPAN_CLASS;
    span.setAttribute("aria-hidden", "true");
    Object.assign(span.style, { position: "absolute", top: "0", left: "0", height: "100%", pointerEvents: "none" });
    first.appendChild(span);
  }
  if (window.getComputedStyle(first).position === "static") first.style.position = "relative";

  // Re-measured every time the step resolves — column widths change with data.
  span.style.width = `${last.getBoundingClientRect().right - first.getBoundingClientRect().left}px`;
  return span;
}
